import API, { Endpoints } from "services/api";

export interface FetchedField {
    fieldId: string;
    name: string;
    dataType: string;
    description?: string;
    active?: boolean;
    isPrimaryKey?: boolean;
    isSortKey?: boolean;
    isRequired?: boolean;
    isPII?: boolean;
    version?: number;
    [key: string]: unknown;
}

export interface FetchedSchema {
    schemaId: string;
    name: string;
    description?: string;
    businessAreaId: string;
    active?: boolean;
    version?: number;
    fields?: FetchedField[];
    [key: string]: unknown;
}

export async function fetchSchemaById(
    tenantId: string,
    businessAreaId: string,
    schemaId: string,
): Promise<FetchedSchema | null> {
    const api = new API();
    const result = await api.get(`${Endpoints.schemas}/api/v1/businessareas/${businessAreaId}/schemas/${schemaId}`, { tenantid: tenantId });
    return result?.data ?? null;
}
